export enum HomeDataTestIdEnum {
  HOME_ALERT_NO_LOCATION = 'home--alert-no-location',
  HOME_BANNER_SECTION = 'home--banner-section',
  HOME_BENEFITS_SECTION = 'home--benefits-section',
  HOME_BRAND_SECTION = 'home--brand-section',
  HOME_CAROUSEL = 'home-carousel',
  HOME_FACE_TO_FACE_SECTION = 'home--face-to-face-service-section',
  HOME_FAVORITES_SECTION = 'favorites-title--card-home',
  HOME_FIND_PHYSICAL_UNIT_SECTION = 'home--find-physical-unit-section',
  HOME_LOCATION_CONTAINER = 'location-container',
  HOME_LOCATION_SEARCH_INPUT = 'search-input--location-modal',
  HOME_MOST_SEARCHED_ALERT_BANNER = 'most-searched-alert-banner',
  HOME_MOST_SEARCHED_ITEM = 'most-searched-item',
  HOME_MOST_SEARCHED_ITEM_PRICE = 'home-most-searched-item-price',
  HOME_MOST_SEARCHED_SECTION = 'home--most-searched-section',
  HOME_PHYSICAL_UNITS_SECTION = 'home--physical-units-section',
  HOME_SEARCH_INPUT_SECTION = 'home--search-input-section',
  HOME_SEARCH_TITLE = 'home--search-title',
  HOME_TESTIMONIAL_SECTION = 'home--testimonial-section',
  PHYSICAL_UNITS_BUTTON_WHATS_APPOINTMENT = 'physical-units--button-whats-appointment',
  PHYSICAL_UNITS_CARD = 'physical-units--card',
  PHYSICAL_UNITS_CAROUSEL = 'physical-units--carousel',
  SEARCH_MODAL = 'generic-modal--search-modal',
  SIGN_IN_MODAL = 'generic-modal--sign-in-modal',
  TESTIMONIAL_CARROUSEL = 'tes-carousel-about-us',
  TESTIMONIAL_SECTION_ABOUT_US = 'testimonial-section-about-us',
}
